import { Navigate } from "react-router-dom";

// ─── Per-system route slices ──────────────────────────────────────────────────
import { authPublicRoutes } from "./Components/AuthRoutes";
import { globoPatientPublicRoutes, globoPatientProtectedRoutes } from "./Components/GloboPatientRoutes";

// ─── Assembled route tables ───────────────────────────────────────────────────
export var authProtectedRoutes = [
    // Catch-alls — must stay last
    { path: "/", exact: true, component: <Navigate to="/globo-patient/dashboard" /> },
    { path: "*", component: <Navigate to="/pages-coming-soon" /> },
];

export var publicRoutes = [
    ...authPublicRoutes,
];

// ← Bagong export para sa MedCare
export var globoPatientPublic    = globoPatientPublicRoutes;
export var globoPatientProtected = globoPatientProtectedRoutes;